













































import {Component, Vue, Watch} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {Company, CompanyFilters} from "@/interfaces/company.interface";
import CompanyEdit from '@/components/CompanyEdit.vue';
import {VuetifyPaginationInterface} from "@/interfaces/vuetify-pagination.interface";
import {CompaniesState} from "@/store/companies.store";

const companiesModule = namespace('companies');

@Component({
  components: {
    CompanyEdit
  }
})
export default class PermissionsTable extends Vue {
  @companiesModule.State companies!: CompaniesState;
  @companiesModule.State totalItems!: number;
  @companiesModule.Action deleteWithConfirmation: any;
  @companiesModule.Action fetchCompanies: any;
  @companiesModule.Action setPagination: any;
  @companiesModule.State companyFilters!: CompanyFilters;
  pagination: VuetifyPaginationInterface = this.$store.state.companies.pagination;
  loading: boolean = false;

  @Watch('pagination', {immediate: true, deep: true})
  async paginationWatcher() {
    this.loading = true;
    this.setPagination({pagination: this.pagination});
    await this.fetchCompanies();
    this.loading = false;
  }

  get search(): string {
    return this.companyFilters.search || '';
  }

  get headers() {
    return [
      {sortable: false, text: 'Name', value: 'name'},
      {sortable: false, text: 'Country', value: 'country'},
      {sortable: false, text: 'City', value: 'city'},
      {sortable: false, text: 'Street', value: 'street'},
      {sortable: false, text: 'Zip', value: 'zip'},
      {sortable: false, text: 'More', value: 'more'},
      {sortable: false, text: 'Default contact', value: 'defaultContact'},
      {sortable: false, text: 'Default phone', value: 'defaultPhone'},
      {sortable: false, text: '# of uses', value: 'countConsignee'},
      {sortable: false, text: '', value: ''}
    ]
  }

  async deleteCompany(company: Company): Promise<any> {
    return await this.deleteWithConfirmation({company});
  }

  get paginationItems(): any[] {
    return [50, 500, {text: "All", value: -1}];
  }
}
